import { Link } from "react-router-dom";
import { Waves, Phone, Mail, MapPin } from "lucide-react";
import { SITE } from "@/lib/site";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/rooms", label: "Rooms" },
  { to: "/about", label: "About Us" },
  { to: "/facilities", label: "Facilities" },
  { to: "/gallery", label: "Gallery" },
  { to: "/location", label: "Location" },
  { to: "/contact", label: "Contact" },
  { to: "/book", label: "Book Now" },
];

const POLICIES = [
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms & Conditions" },
  { to: "/cancellation-policy", label: "Cancellation Policy" },
  { to: "/refund-policy", label: "Refund Policy" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="grain relative bg-navy text-sand">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-20 md:grid-cols-2 lg:grid-cols-4 lg:px-10">
        <div>
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center border border-gold/40 text-gold">
              <Waves size={20} strokeWidth={1.5} />
            </span>
            <span className="font-display text-xl font-semibold">{SITE.name}</span>
          </div>
          <p className="mt-5 font-display text-lg italic text-gold">“{SITE.tagline}”</p>
          <p className="mt-3 text-sm leading-relaxed text-sand/60">
            {SITE.operator}. A seafront stay in Prabhas Patan, Somnath, moments from the Jyotirlinga temple.
          </p>
        </div>

        <div>
          <p className="overline-label !text-gold">Explore</p>
          <ul className="mt-5 space-y-3">
            {NAV.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm text-sand/70 transition-colors duration-300 hover:text-gold">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="overline-label !text-gold">Contact</p>
          <ul className="mt-5 space-y-4 text-sm text-sand/70">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="mt-0.5 shrink-0 text-gold" strokeWidth={1.5} />
              <span>{SITE.address}</span>
            </li>
            <li>
              <a href={`tel:${SITE.phoneHref}`} data-testid="footer-phone" className="flex items-center gap-3 transition-colors duration-300 hover:text-gold">
                <Phone size={16} className="shrink-0 text-gold" strokeWidth={1.5} /> {SITE.phoneDisplay}
              </a>
            </li>
            <li>
              <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="flex items-center gap-3 transition-colors duration-300 hover:text-gold">
                <Mail size={16} className="shrink-0 text-gold" strokeWidth={1.5} /> {SITE.email}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="overline-label !text-gold">Policies</p>
          <ul className="mt-5 space-y-3">
            {POLICIES.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`footer-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-sm text-sand/70 transition-colors duration-300 hover:text-gold">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
          <Link to="/book" data-testid="footer-book-btn" className="btn-primary mt-8 !px-6 !py-3">
            Book Your Stay
          </Link>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-5 py-6 text-xs text-sand/50 md:flex-row lg:px-10">
          <span>© {new Date().getFullYear()} {SITE.name}. All rights reserved.</span>
          <span>{SITE.operator}</span>
        </div>
      </div>
    </footer>
  );
}
